export default {
  ann_arbor_stadium:
    `<table>
        <thead>
          <tr>
            <th>Stádium</th>
            <th>Kiegészítő</th>
            <th>Meghatározás</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td id="col1" rowspan="2"><strong>I</strong></td>
            <td id="col1">&nbsp;</td>
            <td id="col2">Egy nyirokcsomó régió érintettsége</td>
          </tr>
          <tr>
            <td id="col1"><strong>E</strong></td>
            <td id="col2">Egy extralymphaticus szerv érintettsége</td>
          </tr>
          <tr>
            <td id="col1" rowspan="2"><strong>II</strong></td>
            <td id="col1">&nbsp;</td>
            <td id="col2">Két vagy több nyirokcsomó régió érintettsége a rekesz egyik oldalán</td>
          </tr>
          <tr>
            <td id="col1"><strong>E</strong></td>
            <td id="col2">Egy extralymphaticus szövetre vagy szervre terjedés vagy egy szerv/szövet érintettsége a regionális
              nyirokcsomójával további nodalis érintettséggel vagy anélkül a rekesz azonos oldalán
            </td>
          </tr>
          <tr>
            <td id="col1" rowspan="4"><strong>III</strong></td>
            <td id="col1">&nbsp;</td>
            <td id="col2">Nyirokcsomó régiók érintettsége a rekesz mindkét oldalán</td>
          </tr>
          <tr>
            <td id="col1"><strong>E</strong></td>
            <td id="col2">A rekesz kétoldalán levő nyirokcsomó érintettség mellett kapcsolódó extralymphaticus szerv/szövet érintettsége
            </td>
          </tr>
          <tr>
            <td id="col1"><strong>S</strong></td>
            <td id="col2">Rekesz kétoldalán lévő nyirokcsomó érintettség a lép érintettségével</td>
          </tr>
          <tr>
            <td id="col1"><strong>ES</strong></td>
            <td id="col2">E+S: a fentiek együttese</td>
          </tr>
          <tr>
            <td id="col1"><strong>IV</strong></td>
            <td id="col1">&nbsp;</td>
            <td id="col2">Egy vagy több extralymphaticus szerv érintettsége nyirokcsomó érintettség nélkül vagy izolált extralymphaticus
              szerv érintettsége nem regionális nyirokcsomó érinettséggel
            </td>
          </tr>
          <tr>
            <td id="col1"><strong>A</strong></td>
            <td id="col1">&nbsp;</td>
            <td id="col2">Általános tünetek nélkül</td>
          </tr>
          <tr>
            <td id="col1"><strong>B</strong></td>
            <td id="col1">&nbsp;</td>
            <td id="col2">Tisztázatlan 38 fok feletti láz és/vagy „eláztató” éjszakai izzadás és/vagy a testsúly 10 %-át meghaladó
              súlyvesztés a diagnózis előtti 6 hónap alatt
            </td>
          </tr>
        </tbody>
      </table>`,
  ann_arbor_stadium_lugano:
    `<table>
      <thead>
        <tr>
          <th colspan="2">Stádium</th>
          <th>Kiegészítő</th>
          <th>Meghatározás</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="3">Limitált betegség</td>
          <td><strong>I</strong></td>
          <td>Egy régió vagy szomszédos regiók érintettsége</td>
          <td>Egy extranodális régió nodalis érintettség nélkül</td>
        </tr>
        <tr>
          <td><strong>II</strong></td>
          <td>Két vagy több nyirokcsomócsoport érintett a rekesz egyik oldalán</td>
          <td>I-II. stádiumú nodalis kiterjedés limitált extranodalis réterjedésel</td>
        </tr>
        <tr>
          <td><strong>II bulky</strong></td>
          <td>II stádium 6 cm-nél nagyobb masszával</td>
          <td>Nem alkalmazható</td>
        </tr>
        <tr>
          <td rowspan="2">Előrehaladott betegség</td>
          <td><strong>III</strong></td>
          <td>A rekesz mindkét oldalán érintett nyirokcsomók vannak vagy a rekesz feletti nyirokcsomó manifesztáció mellett
            lép érintettség áll fenn
          </td>
          <td>Nem alkalmazható</td>
        </tr>
        <tr>
          <td><strong>IV</strong></td>
          <td>Nem ráterjedéses extranodalis érintettség áll fenn</td>
          <td>Nem alkalmazható</td>
        </tr>
      </tbody>
    </table>`,
  nccn_prognozis:
    `<p><span style="font-weight: 400;">Bármelyik jelenléte kedvezőtlen:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor: ≥ 50 év</span></li>
      <li><span style="font-weight: 400;">We: B-tünet mellett > 30 mm/ó</span></li>
      <li><span style="font-weight: 400;">We: B-tünet mellett > 50 mm/ó</span></li>
      <li><span style="font-weight: 400;">Mediastinalis massza : MTR > 0.35</span></li>
      <li><span style="font-weight: 400;">Érintett nyirokrégiók száma > 3</span></li>
    </ul>`,
  ipi_score_ertek:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Férfi</span></li>
      <li><span style="font-weight: 400;">Életkor ≥ 45 év</span></li>
      <li><span style="font-weight: 400;">Szérum albumin : 40 g/l alatt</span></li>
      <li><span style="font-weight: 400;">Hgb: 105 g/l alatt</span></li>
      <li><span style="font-weight: 400;">Fvs: ≥ 15.0 G/l</span></li>
      <li><span style="font-weight: 400;">Abszolut lymphocyta szám: 0.6 G/l alatt vagy lymphocyta arányszám 8% alatt
        </span></li>
      <li><span style="font-weight: 400;">Kiterjedés: IV. stadium</span></li>
    </ul>`,
  flipi_1:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Életkor ≥ 45 év</span></li>
      <li><span style="font-weight: 400;">Ann-Arbor: III-IV</span></li>
      <li><span style="font-weight: 400;">Hemoglobin: 120 g/l alatt</span></li>
      <li><span style="font-weight: 400;">szérum LDH: normál érték felett</span></li>
      <li><span style="font-weight: 400;">Érintett nodalis régiók száma ≥ 5</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low risk</strong></td>
            <td>0-1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>Intermedier risk</strong></td>
            <td>2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High risk</strong></td>
            <td> ≥ 3 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  flipi_2:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Életkor ≥ 60 év</span></li>
      <li><span style="font-weight: 400;">Szérum béta-2-microglobulin: Normál felett</span></li>
      <li><span style="font-weight: 400;">Hemoglobin: 120 g/l alatt</span></li>
      <li><span style="font-weight: 400;">Csontvelő érintettség: van</span></li>
      <li><span style="font-weight: 400;">A legnagyobb érintett régió kiterjedése ≥ 6cm</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low risk</strong></td>
            <td>0-1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>Intermedier risk</strong></td>
            <td>2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High risk</strong></td>
            <td> ≥ 3 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  gastrointestinalis_malt_limf_stad:
    `<table>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Lugano modifikált Ann-Arbor staging</th>
          <th>TNM</th>
          <th>Tumor kiterjedés</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="3">Gastrointestinumra korlátozott</td>
          <td rowspan="3">IE</td>
          <td>T1 N0 M0</td>
          <td>mucosa, submucosa</td>
        </tr>
        <tr>
          <td>T2 N0 M0</td>
          <td>muscularis propria</td>
        </tr>
        <tr>
          <td>T3 N0 M0</td>
          <td>serosa</td>
        </tr>
        <tr>
          <td rowspan="4">Hasba terjedő</td>
          <td rowspan="3">IIE</td>
          <td>T1-3 N1 M0</td>
          <td>fali nyirokcsomók</td>
        </tr>
        <tr>
          <td>T1-3 N2 M0</td>
          <td>távolabbi regionális nyirokcsomók</td>
        </tr>
        <tr>
          <td>T4 N0 M0</td>
          <td>határos struktúrák infiltrációja</td>
        </tr>
        <tr>
          <td>IV</td>
          <td>
                <span class="ui-label">
                  T1-4 N3 M0</span>
                <span class="ui-label">
                  T1-4 N0-3 M1</span>
          </td>
          <td>a rekesz mindkét oldalán nyirokcsomó érintettség és/vagy távoli metastasis ( pl. csontvelő vagy más
            extranodalis szerv érintettsége)</td>
        </tr>
      </tbody>
    </table>`,
  ipi_kategoria:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Életkor > 60 év</span></li>
      <li><span style="font-weight: 400;">Ecog státusz: 2-4</span></li>
      <li><span style="font-weight: 400;">Ann-Arbor stádium: III-IV</span></li>
      <li><span style="font-weight: 400;">Szérum LDH: normál érték felett</span></li>
      <li><span style="font-weight: 400;">Érintett extranodalis régiók száma > 1</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low</strong></td>
            <td>0-1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>Low-intermedier</strong></td>
            <td>2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High-intermedier</strong></td>
            <td>3 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High</strong></td>
            <td>4-5 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  korcsoporthoz_alakitott_ipi_kat:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Ecog státusz: 2-4</span></li>
      <li><span style="font-weight: 400;">Ann-Arbor stádium: III-IV</span></li>
      <li><span style="font-weight: 400;">Szérum LDH: normál érték felett</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low</strong></td>
            <td>Nincs pozitívum</td>
          </tr>
          <tr>
            <td><strong>Low-intermedier</strong></td>
            <td>1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High-intermedier</strong></td>
            <td> 2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High</strong></td>
            <td>3 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  stadiumhoz_alakitott_ipi_kat:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor > 60 év</span></li>
      <li><span style="font-weight: 400;">Ann-Arbor stádium: II-IIE</span></li>
      <li><span style="font-weight: 400;">Szérum LDH: normál érték felett</span></li>
      <li><span style="font-weight: 400;">Ecog status: 2-4</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low</strong></td>
            <td>0-1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High</strong></td>
            <td>2-4 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  rizikocsoport:
    `<p><span style="font-weight: 400;">Kis kockázat:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Normális LDH</span></li>
      <li><span style="font-weight: 400;">I.stádium és teljesen eltávolítható hasi lézió</span></li>
      <li><span style="font-weight: 400;">Egy extra-abdominális 10 cm-nél kisebb tumor</span></li>
    </ul>
    <p><span style="font-weight: 400;">Nagy kockázat:</span></p>
    <ul>
      <li><span style="font-weight: 400;">I.stádium és hasi tumormassza</span></li>
      <li><span style="font-weight: 400;">Extra-abdominális 10 cm-nél nagyobb tumor</span></li>
      <li><span style="font-weight: 400;">II-IV. stádium</span></li>
    </ul>`,
  pitInfo:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor > 60 év</span></li>
      <li><span style="font-weight: 400;">Van csontvelő érintettség</span></li>
      <li><span style="font-weight: 400;">Szérum LDH: normál érték felett</span></li>
      <li><span style="font-weight: 400;">Ecog status: 2-4</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>1. csoport</strong></td>
            <td>Nincs pozitívum</td>
          </tr>
          <tr>
            <td><strong>2. csoport</strong></td>
            <td>1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>3. csoport</strong></td>
            <td> 2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>4. csoport</strong></td>
            <td>3 vagy 4 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  modositott_pitInfo:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor > 60 év</span></li>
      <li><span style="font-weight: 400;">Ki-67 ≥ 80% </span></li>
      <li><span style="font-weight: 400;">Szérum LDH: normál érték felett</span></li>
      <li><span style="font-weight: 400;">Ecog status: 2-4</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>1. csoport</strong></td>
            <td>Nincs pozitívum</td>
          </tr>
          <tr>
            <td><strong>2. csoport</strong></td>
            <td> 2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>3. csoport</strong></td>
            <td> 3-4 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  itcl_project_kategoria:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor > 60 év</span></li>
      <li><span style="font-weight: 400;">Tct-szám < 150 g/l </span> </li> <li><span style="font-weight: 400;">Ecog
              status: 2-4</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>1. csoport</strong></td>
            <td>Nincs pozitívum</td>
          </tr>
          <tr>
            <td><strong>2. csoport</strong></td>
            <td> 1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>3. csoport</strong></td>
            <td> 2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>4. csoport</strong></td>
            <td> 3 pozitívum</td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  pink:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor > 60 év</span></li>
      <li><span style="font-weight: 400;">Van távoli nyirokcsomó érintettség </span></li>
      <li><span style="font-weight: 400;">Ann-Arbor stádium: III-IV</span></li>
      <li><span style="font-weight: 400;">Nem nasalis típusú betegség</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low</strong></td>
            <td>Nincs pozitívum</td>
          </tr>
          <tr>
            <td><strong>Intermedier</strong></td>
            <td> 1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High</strong></td>
            <td>≥ 2 pozitívum </td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  pink_e:
    `<p><span style="font-weight: 400;">Mindegyik egy pontot ér:</span></p>
    <ul>
      <li><span style="font-weight: 400;">Kor > 60 év</span></li>
      <li><span style="font-weight: 400;">Van távoli nyirokcsomó érintettség </span></li>
      <li><span style="font-weight: 400;">Ann-Arbor stádium: III-IV</span></li>
      <li><span style="font-weight: 400;">Nem nasalis típusú betegség</span></li>
      <li><span style="font-weight: 400;">EBV DNS pozitív</span></li>
      <table>
        <thead>
          <tr>
            <th>Érték</th>
            <th>Pontszám</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Low</strong></td>
            <td>0-1 pozitívum</td>
          </tr>
          <tr>
            <td><strong>Intermedier</strong></td>
            <td> 2 pozitívum</td>
          </tr>
          <tr>
            <td><strong>High</strong></td>
            <td>≥ 3 pozitívum </td>
          </tr>
        </tbody>
      </table>
    </ul>`,
  tnm_besorolas:
    `<table>
      <thead>
        <tr>
          <th>Érték</th>
          <th>Pontszám</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2"><strong>T1</strong>Szoliter bőr érintettség</td>
          <td>1a</td>
          <td>
            < 5cm</td> </tr> <tr>
          <td>1b</td>
          <td> > 5cm</td>
        </tr>
        <tr>
          <td rowspan="3"><strong>T2</strong>Egy vagy két egymásban folytatódó testrégió érintett</td>
          <td>2a</td>
          <td>Az összes érintettség területe < 15cm</td> </tr> <tr>
          <td>2b</td>
          <td>Az összes érintettség területe 15-30cm</td>
        </tr>
        <tr>
          <td>2c</td>
          <td>Az összes érintettség területe > 30cm</td>
        </tr>
        <tr>
          <td rowspan="2"><strong>T3</strong>Generalizált bőr érintettség</td>
          <td>3a</td>
          <td>2 nem érintkező bőrrégió érintett</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>Legalább 3 nem érintkező régió érintett</td>
        </tr>
        <tr>
          <td rowspan="4"><strong>N</strong>&nbsp;</td>
          <td>N0</td>
          <td>nincs nyirokcsomó érintettség</td>
        </tr>
        <tr>
          <td>N1</td>
          <td>egy periferiás regió érintett, mely drenálja az aktuális vagy korábbi bőrérintettség helyét</td>
        </tr>
        <tr>
          <td>N2</td>
          <td>2 vagy több perifériás drenáló vagy bárhol nem drenáló régió érinett</td>
        </tr>
        <tr>
          <td>N3</td>
          <td>centrális nyirokcsomó érintettség</td>
        </tr>
        <tr>
          <td rowspan="2"><strong>M</strong>&nbsp;</td>
          <td>M0</td>
          <td>nincs jele extracutan és nem-nyirokcsomó betegségnek</td>
        </tr>
        <tr>
          <td>M1</td>
          <td>extracutan nem nyirokcsomó betegség van</td>
        </tr>
      </tbody>
    </table>`,
  tnmb_besorolas:
    `<table>
      <thead>
        <tr>
          <th colspan="2">TNMB</th>
          <th>Kritériumok</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="6">bőr</td>
          <td>T1</td>
          <td>limitált foltok, papulák, plakkok, melyek a bőrfelszín < 10%-át érintik</td> </tr> <tr>
          <td>T2</td>
          <td>legalább 10 %</td>
        </tr>
        <tr>
          <td>T2a</td>
          <td>csak folt</td>
        </tr>
        <tr>
          <td>T2b</td>
          <td>plakk</td>
        </tr>
        <tr>
          <td>T3</td>
          <td>egy vagy több 1legalább 1 cm-es tumor</td>
        </tr>
        <tr>
          <td>T4</td>
          <td>összefolyó erythema a testfelszín leaglább 80 %-án</td>
        </tr>
        <tr>
          <td rowspan="5">nycs</td>
          <td>N0</td>
          <td>nincs abnormis nyirokcsomó</td>
        </tr>
        <tr>
          <td>N1</td>
          <td>abnormis nyirokcsomó Dutch gr1 vagy NCI LN 0-2</td>
        </tr>
        <tr>
          <td>N2</td>
          <td>gr 2 3</td>
        </tr>
        <tr>
          <td>N3</td>
          <td>gr 3-4 4</td>
        </tr>
        <tr>
          <td>NX</td>
          <td>abnormis nyirokcsomó szövettani megerősítés nélkül</td>
        </tr>
        <tr>
          <td rowspan="3">visceralis</td>
          <td>M0</td>
          <td>nincs visceralis szerv érintettség</td>
        </tr>
        <tr>
          <td>M1</td>
          <td>visceralis érintettség van ( szövettani megerősítéssel, szerv megnevezésével )</td>
        </tr>
        <tr>
          <td>MX</td>
          <td>visceralis érintettség szövettani megerősítés nélkül</td>
        </tr>
        <tr>
          <td rowspan="3">vér</td>
          <td>B0</td>
          <td>
            <p><span style="font-weight: 400;">Nincs érdemi vér érintettség</span></p>
            <ul>
              <li><span style="font-weight: 400;">a lymphocyták ≤ 5%-a vagy < 250/ul atípusos (Sezary) sejt </span> </li>
                    <li><span style="font-weight: 400;">a lymphocyták között < 15% CD4+/CD26- vagy CD4+/CD7- sejt </span>
                        </li> </ul> </td> </tr> <tr>
          <td>B1</td>
          <td>
            <p><span style="font-weight: 400;">kis vérbeli tumortömeg</span></p>
            <ul>
              <li><span style="font-weight: 400;">a lymphocyták > 5%-a atípusos (Sezary) sejt </span></li>
              <li><span style="font-weight: 400;">a lymphocyták között ≥ 15% CD4+/CD26- </span></li>
              <li><span style="font-weight: 400;">CD4+/CD7- sejt, nem meríti ki a B0 vagy B2 kritériumait</span></li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>B2</td>
          <td>
            <p><span style="font-weight: 400;">nagy vérbeli tumortömeg</span></p>
            <ul>
              <li><span style="font-weight: 400;">≥ 1000/ul Sezary-sejt ( CD4+/CD26- vagy CD4+/CD7-) </span></li>
              <li><span style="font-weight: 400;">az összes lymphocyta között CD4/CD8 ≥ 10</span></li>
              <li><span style="font-weight: 400;">az összes lymphocyta között CD4+/CD7- sejtarány ≥ 40%</span></li>
              <li><span style="font-weight: 400;">az összes lymphocyta között CD4+/CD26- sejtarány ≥ 30%</span></li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>`,
  klinikai_stadium:
    `<table>
      <thead>
        <tr>
          <th>Klinikai stádium</th>
          <th>T(bőr)</th>
          <th>N(nycs)</th>
          <th>M(visceralis)</th>
          <th>B(vér)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>&nbsp;</td>
          <td colspan="2">Nagysejtes transzformáció</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td><strong>IA</strong><br>limitált bőr érintettség</td>
          <td>T1</td>
          <td>N0</td>
          <td>M0</td>
          <td>B0-B1</td>
        </tr>
        <tr>
          <td><strong>IB</strong><br>csak bőrbetegség</td>
          <td>T2</td>
          <td>N0</td>
          <td>M0</td>
          <td>B0-B1</td>
        </tr>
        <tr>
          <td><strong>IIA</strong></td>
          <td>T1-2</td>
          <td>N1-2</td>
          <td>M0</td>
          <td>B0-B1</td>
        </tr>
        <tr>
          <td><strong>IIB</strong><br>tumor stádiumú betegség</td>
          <td>T3</td>
          <td>N0-2</td>
          <td>M0</td>
          <td>B0-B1</td>
        </tr>
        <tr>
          <td><strong>IIIA</strong><br>erythrodermiás betegség</td>
          <td>T4</td>
          <td>N0-2</td>
          <td>M0</td>
          <td>B0</td>
        </tr>
        <tr>
          <td><strong>IIIB</strong><br>erythrodermiás betegség</td>
          <td>T4</td>
          <td>N0-2</td>
          <td>M0</td>
          <td>B1</td>
        </tr>
        <tr>
          <td><strong>IV A1</strong></td>
          <td>T1-4</td>
          <td>N0-2</td>
          <td>M0</td>
          <td>B1</td>
        </tr>
        <tr>
          <td><strong>IV A2</strong></td>
          <td>T1-4</td>
          <td>N3</td>
          <td>M0</td>
          <td>B0-2</td>
        </tr>
        <tr>
          <td><strong>IV B</strong></td>
          <td>T1-4</td>
          <td>N0-3</td>
          <td>M1</td>
          <td>B0-2</td>
        </tr>
      </tbody>
    </table>`,
  durie_salmon_stadium:
    `<table>
    <thead>
      <tr>
        <th>Durie-Salmon</th>
        <th>I</th>
        <th>II</th>
        <th>III</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>hgb</td>
        <td>100 g/l felett</td>
        <td>85-100</td>
        <td>85 alatt</td>
      </tr>
      <tr>
        <td>Ca</td>
        <td>3.00 mmol/l alatt</td>
        <td>3.00 mmol/l alatt</td>
        <td>3.00 mmol/l felett</td>
      </tr>
      <tr>
        <td>M-protein: IgA</td>
        <td>30 g/l alatt</td>
        <td>30-50</td>
        <td>50 felett</td>
      </tr>
      <tr>
        <td>M-protein: IgB</td>
        <td>50 g/l alatt</td>
        <td>50-70</td>
        <td>70 felett</td>
      </tr>
      <tr>
        <td>Bence-Jones protein</td>
        <td>4 g/nap alatt</td>
        <td>4-12</td>
        <td>12 felett</td>
      </tr>
      <tr>
        <td>rtg eltérés</td>
        <td>legfeljebb szoliter</td>
        <td>többszörös csontérintettség</td>
        <td>többszörös csontérintettség</td>
      </tr>
    </tbody>
  </table>
  <br>
  <table>
    <thead>
      <tr>
        <th>A/B</th>
        <th>A</th>
        <th>B</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>szérum-kreatinin</td>
        <td>max. 177 umol/l</td>
        <td>több</td>
      </tr>
    </tbody>
  </table>`,
  durie_salmon_modosito:
    `<table>
      <thead>
        <tr>
          <th>Durie-Salmon</th>
          <th>I</th>
          <th>II</th>
          <th>III</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>hgb</td>
          <td>100 g/l felett</td>
          <td>85-100</td>
          <td>85 alatt</td>
        </tr>
        <tr>
          <td>Ca</td>
          <td>3.00 mmol/l alatt</td>
          <td>3.00 mmol/l alatt</td>
          <td>3.00 mmol/l felett</td>
        </tr>
        <tr>
          <td>M-protein: IgA</td>
          <td>30 g/l alatt</td>
          <td>30-50</td>
          <td>50 felett</td>
        </tr>
        <tr>
          <td>M-protein: IgB</td>
          <td>50 g/l alatt</td>
          <td>50-70</td>
          <td>70 felett</td>
        </tr>
        <tr>
          <td>Bence-Jones protein</td>
          <td>4 g/nap alatt</td>
          <td>4-12</td>
          <td>12 felett</td>
        </tr>
        <tr>
          <td>rtg eltérés</td>
          <td>legfeljebb szoliter</td>
          <td>többszörös csontérintettség</td>
          <td>többszörös csontérintettség</td>
        </tr>
      </tbody>
    </table>
    <br>
    <table>
      <thead>
        <tr>
          <th>A/B</th>
          <th>A</th>
          <th>B</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>szérum-kreatinin</td>
          <td>max. 177 umol/l</td>
          <td>több</td>
        </tr>
      </tbody>
    </table>`,
  iss_stadium:
    `<table>
      <thead>
        <tr>
          <th>ISS</th>
          <th>Leírás</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>I</td>
          <td>szérum β2mikroglobulin 5.5 ug/ml alatt<br> szérum albumin minimum 35 g/l </td>
        </tr>
        <tr>
          <td>II</td>
          <td>nem I. vagy III. stádium</td>
        </tr>
        <tr>
          <td>III</td>
          <td>szérum β2mikroglobulin  5.5 ug/ml felett</td>
        </tr>
      </tbody>
    </table>`,
  r_iss_stadium:
    `<table>
      <thead>
        <tr>
          <th>R-ISS</th>
          <th>Leírás</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>I</td>
          <td>ISS I. és standard rizikójú FISH</td>
        </tr>
        <tr>
          <td>II</td>
          <td>nem I vagy III. stádium</td>
        </tr>
        <tr>
          <td>III</td>
          <td>ISS III. mellett vagy nagy kockázatú FISH<br> vagy   normál limit feletti LDH</td>
        </tr>
      </tbody>
    </table>`,
}